import { ReactNode } from "react";

import { Tooltip } from "../../base/tooltip";

/**
 * Renders a list of labels on a single line: the first inline, the rest
 * collapsed behind a ", +N" affordance that reveals them (one per line) in a
 * hover tooltip. Empty/blank labels are dropped. Shows `empty` when nothing
 * remains. Keeps table rows a uniform height when a cell can hold many values.
 */
export function CellTooltipList({
  items,
  empty = "",
}: {
  items: Array<string | null | undefined>;
  empty?: ReactNode;
}) {
  const labels = items.filter((label): label is string => !!label);

  if (labels.length === 0) return <span>{empty}</span>;
  if (labels.length === 1) return <span>{labels[0]}</span>;

  return (
    <>
      {labels[0]}
      <Tooltip
        content={
          <div>
            {labels.slice(1).map((label, index) => (
              <div key={index}>{label}</div>
            ))}
          </div>
        }
      >
        <span className="inline-block cursor-help">, +{labels.length - 1}</span>
      </Tooltip>
    </>
  );
}
